import baseApi from "../api/baseApi";

const courseSessionApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getStudentEnrollmentSessions: builder.query({
      query: (enrollmentId) => ({
        url: `/coursesession/student/enrollment/${enrollmentId}/sessions`,
        method: "GET",
      }),
      providesTags: ["Enrollments"],
    }),
  }),
});

export const { useGetStudentEnrollmentSessionsQuery } = courseSessionApi;

export default courseSessionApi;
